import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Spinner from 'web/components/Spinner';
import Layout from 'web/components/Layout';
import { Container, Heading } from './faqStyled'
import FaqTabs from 'web/pages/private/CommonPages/Faq/FaqTabs'
import { fetchLanguageContentNew } from 'redux/actions/language';

const Faq = (props) => {
    let dispatch = useDispatch();
    const loaderVisible = useSelector(
        (state) => state.appReducer.loaderVisible
    );

    // const urlObject = useSelector(
    //     (state) => state.urlParameters.faq
    // );

    const currentLanguage = useSelector(state => state.language.currentLanguage)
    const languageContentNew = useSelector(state => state.language.languageContentNew)
    const [pageLanguageContents, setPageLanguageContents] = useState()
    const [pageHeaderContents, setPageHeaderContents] = useState()
    const [sectionHeading, setSectionHeading] = useState([])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (languageContentNew?.FAQ_Page) setPageLanguageContents(languageContentNew.FAQ_Page)
        if (languageContentNew?.FAQ_Heading_Page) setPageHeaderContents(languageContentNew.FAQ_Heading_Page)
        else dispatch(fetchLanguageContentNew(currentLanguage))
    }, [languageContentNew])

    useEffect(() => {
        if (pageHeaderContents?.Headings) {
            let tempHeadings = pageHeaderContents.Headings.map(val => Object.values(val))
            setSectionHeading(tempHeadings.flat())
        }
    }, [pageHeaderContents])

    return (<>
        <Layout pageType="Faq" topBarViewMobile={"hide"}>
            {loaderVisible && <Spinner />}
            <Container>
                <Heading>FAQ</Heading>
                <FaqTabs sectionHeading={sectionHeading} pageLanguageContents={pageLanguageContents} />
            </Container>
        </Layout>
    </>)
};

export default Faq;